import { money } from "@/lib/format";
import type { Summary } from "@/lib/types";

export default function ProfitBreakdown({ summary }: { summary: Summary }) {
  const rows = [
    { label: "Ingresos por ventas", value: summary.salesIncome, sign: "+" },
    { label: "Gastos adicionales", value: summary.extraExpenses, sign: "-" },
    { label: "Dinero recuperado por devoluciones", value: summary.refundsRecovered, sign: "+" },
    { label: "Valor estimado del inventario", value: summary.inventoryValue, sign: "" },
  ];
  return (
    <div className="rounded-3xl border border-background-200/70 bg-background-50 p-4 shadow-card">
      <p className="text-[14px] font-semibold text-foreground-900">Detalle del período</p>
      <div className="mt-3 space-y-2.5">
        {rows.map((row) => (
          <div key={row.label} className="flex items-center justify-between">
            <span className="text-[13px] text-foreground-600">{row.label}</span>
            <span className="tabular-nums text-[13px] font-semibold text-foreground-900">
              {row.sign}
              {money(row.value, summary.currency)}
            </span>
          </div>
        ))}
        <div className="flex items-center justify-between border-t border-background-200 pt-2.5">
          <span className="text-[13px] font-medium text-foreground-700">Ganancia neta</span>
          <span
            className={`tabular-nums text-[15px] font-bold ${
              summary.netProfit >= 0 ? "text-primary-700" : "text-red-600"
            }`}
          >
            {money(summary.netProfit, summary.currency)}
          </span>
        </div>
      </div>
    </div>
  );
}